import { render, staticRenderFns } from "./select-widget.vue?vue&type=template&id=48d2bc59&scoped=true&"
import script from "./select-widget.vue?vue&type=script&lang=js&"
export * from "./select-widget.vue?vue&type=script&lang=js&"
import style0 from "./select-widget.vue?vue&type=style&index=0&id=48d2bc59&prod&lang=scss&scoped=true&"
import style1 from "./select-widget.vue?vue&type=style&index=1&id=48d2bc59&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d2bc59",
  null
  
)

export default component.exports